// extracted by mini-css-extract-plugin
module.exports = {"table":"FileSharing_table__2aQcS"};